import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';

const ExpertServices = () => {
    return (
        <section className="relative py-24 bg-dark-900 overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#C5A028 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>

            <div className="container mx-auto px-6 relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-16">
                    <div className="lg:w-1/2">
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                        >
                            <h3 className="text-gold-500 font-semibold uppercase tracking-widest mb-2">Why Choose Us</h3>
                            <h2 className="text-4xl lg:text-5xl font-serif text-white mb-8 leading-tight">
                                Expertise That Defines <span className="text-gold-400">Luxury</span>
                            </h2>
                            <p className="text-gray-300 text-lg mb-8 leading-relaxed font-light">
                                Our team consists of master craftsmen with decades of experience in high-end residential and commercial projects across the UAE. We don't just maintain; we elevate.
                            </p>

                            <div className="space-y-4">
                                {[
                                    "Italian Marble Restoration Specialists",
                                    "Custom Gold Leafing & Gilding",
                                    "Heritage Conservation Techniques",
                                    "Smart Home Integration for Joinery"
                                ].map((item, index) => (
                                    <div key={index} className="flex items-center space-x-3">
                                        <CheckCircle className="text-gold-500 w-5 h-5 flex-shrink-0" />
                                        <span className="text-white text-lg">{item}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-10">
                                <a href="#contact" className="bg-gold-500 text-white px-8 py-3 rounded-sm font-semibold uppercase tracking-wider hover:bg-gold-600 transition-colors">
                                    Partner With Experts
                                </a>
                            </div>
                        </motion.div>
                    </div>

                    <div className="lg:w-1/2 relative">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            className="grid grid-cols-2 gap-4"
                        >
                            <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Luxury Detail 1" className="rounded-lg shadow-2xl transform translate-y-8" />
                            <img src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Luxury Detail 2" className="rounded-lg shadow-2xl" />
                        </motion.div>
                        {/* Badge */}
                        <div className="absolute -bottom-10 -right-10 bg-white p-6 rounded-full shadow-xl hidden md:block">
                            <div className="text-center">
                                <Star className="w-8 h-8 text-gold-500 mx-auto mb-1" />
                                <span className="block text-2xl font-bold text-dark-900">100%</span>
                                <span className="text-xs uppercase tracking-wide text-gray-500">Quality Guarantee</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExpertServices;
